import { MobileNav } from './MobileNav';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { Outlet, useLocation } from 'react-router-dom';

const ROUTES_WITHOUT_PROPERTY_BAR = new Set(['/configuracoes', '/assinatura']);

function shouldHidePropertyBar(pathname: string): boolean {
  if (ROUTES_WITHOUT_PROPERTY_BAR.has(pathname)) return true;
  if (pathname === '/propriedades' || pathname.startsWith('/propriedades/')) return true;
  return false;
}

export function AppShell() {
  const { pathname } = useLocation();
  const showPropertyBar = !shouldHidePropertyBar(pathname);

  return (
    <div className="flex min-h-screen">
      <Sidebar />
      <div className="flex flex-1 flex-col min-w-0">
        <TopBar showPropertySelector={showPropertyBar} />
        <main className="flex-1 w-full min-w-0 px-4 py-6 sm:px-6 lg:px-8 pb-24 lg:pb-8">
          <Outlet />
        </main>
        <MobileNav />
      </div>
    </div>
  );
}
